import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getLedgerEvent, LedgerEvent } from "../../api";
import { APP_ROUTES } from "../../routes";

export default function LedgerEventDetail() {
  const { id: projectId = "", eventId = "" } = useParams<{
    id: string;
    eventId: string;
  }>();
  const [event, setEvent] = useState<LedgerEvent | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!eventId) return;
    getLedgerEvent(eventId)
      .then(setEvent)
      .catch((e) => setError((e as Error).message));
  }, [eventId]);

  return (
    <div className="manifold-page">
      <header className="manifold-page-header">
        <p className="sg-section-kicker">Compliance · Ledger entry</p>
        <h1>{event ? `Entry #${event.seq}` : "Ledger entry"}</h1>
        {event && (
          <p className="text-muted">
            {event.event_type} · {event.channel} channel ·{" "}
            {event.created_at
              ? new Date(event.created_at).toLocaleString()
              : "—"}
          </p>
        )}
      </header>

      {error && <div className="sample-banner">Could not load entry: {error}</div>}

      {event && (
        <div className="card ledger-detail">
          <dl>
            <dt>Action</dt>
            <dd>{event.action}</dd>
            {event.rationale && (
              <>
                <dt>Rationale</dt>
                <dd>{event.rationale}</dd>
              </>
            )}
            <dt>Actor</dt>
            <dd>{event.actor}</dd>
            {event.destination && (
              <>
                <dt>Destination</dt>
                <dd>{event.destination}</dd>
              </>
            )}
            {event.payload_bytes != null && (
              <>
                <dt>Payload</dt>
                <dd>{event.payload_bytes} bytes</dd>
              </>
            )}
            <dt>Previous hash</dt>
            <dd><code>{event.prev_hash}</code></dd>
            <dt>Entry hash</dt>
            <dd><code>{event.entry_hash}</code></dd>
            <dt>Ed25519 signature</dt>
            <dd><code>{event.signature}</code></dd>
          </dl>
        </div>
      )}

      <div className="egress-actions">
        <Link
          to={APP_ROUTES.compliance(projectId)}
          className="sg-btn sg-btn-secondary"
        >
          Back to ledger
        </Link>
      </div>
    </div>
  );
}
